import React from 'react';
import { Button } from '../../ui/button';
import { Card } from '../../ui/card';
import { Input } from '../../ui/input';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '../../ui/dialog';
import { Package } from 'lucide-react';

export default function ModalCriarResgate({
  open,
  onOpenChange,
  anomaliasProducao = [],
  anomaliasSelecionadas = {},
  setAnomaliasSelecionadas,
  getQuantidadeDisponivelResgate,
  onCriar,
  loading = false,
}) {
  const handleClose = () => {
    onOpenChange(false);
    setAnomaliasSelecionadas({});
  };

  const totalSelecionado = Object.values(anomaliasSelecionadas).reduce(
    (acc, v) => acc + (parseInt(v) || 0), 0
  );

  const anomaliasDisponiveis = anomaliasProducao.filter(
    (a) => a.tipo === 'arranjo' && getQuantidadeDisponivelResgate(a) > 0
  );

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) handleClose(); else onOpenChange(v); }}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-3">
            <Package className="h-6 w-6 text-amber-500" />
            Resgatar Peças para Arranjo
          </DialogTitle>
          <DialogDescription>
            Selecione as anomalias e quantidades que pretende resgatar para arranjo em separado.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          {/* Anomalias disponíveis */}
          <div>
            <h4 className="font-medium text-stone-700 mb-3">Anomalias Disponíveis:</h4>
            {anomaliasDisponiveis.length === 0 ? (
              <p className="text-sm text-stone-500 p-4 bg-stone-50 rounded-lg text-center">
                Não há anomalias disponíveis para resgate.
              </p>
            ) : (
              <div className="space-y-3">
                {anomaliasDisponiveis.map((anomalia) => {
                  const disponivel = getQuantidadeDisponivelResgate(anomalia);
                  const selecionada = anomaliasSelecionadas[anomalia.id] || 0;
                  return (
                    <Card
                      key={anomalia.id}
                      className={`p-4 transition-all ${selecionada > 0 ? 'border-amber-400 bg-amber-50' : ''}`}
                    >
                      <div className="flex items-start justify-between gap-4">
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-1">
                            <span className="text-sm font-medium">{anomalia.operacao_nome || 'Operação'}</span>
                            <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded">
                              {disponivel} disponível
                            </span>
                          </div>
                          {anomalia.observacoes && (
                            <p className="text-xs text-stone-500">{anomalia.observacoes}</p>
                          )}
                        </div>
                        <div className="flex items-center gap-2">
                          <label className="text-xs text-stone-500">Quantidade:</label>
                          <Input
                            type="number"
                            min="0"
                            max={disponivel}
                            value={selecionada || ''}
                            onChange={(e) => {
                              const val = Math.min(parseInt(e.target.value) || 0, disponivel);
                              setAnomaliasSelecionadas((prev) => ({ ...prev, [anomalia.id]: val }));
                            }}
                            className="w-20 h-9 text-center"
                          />
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => setAnomaliasSelecionadas((prev) => ({ ...prev, [anomalia.id]: disponivel }))}
                          >
                            Todas
                          </Button>
                        </div>
                      </div>
                    </Card>
                  );
                })}
              </div>
            )}
          </div>

          {/* Resumo */}
          {totalSelecionado > 0 && (
            <Card className="p-4 bg-amber-50 border-amber-200">
              <h4 className="font-medium text-amber-700 mb-2">Resumo do Resgate:</h4>
              <div className="flex items-center justify-between">
                <span className="text-stone-600">Total de peças a resgatar:</span>
                <span className="text-2xl font-bold text-amber-700">{totalSelecionado}</span>
              </div>
              <p className="text-xs text-stone-500 mt-2">
                Será gerado um documento com a lista de peças e operações em falta.
              </p>
            </Card>
          )}

          <div className="flex gap-3 pt-2">
            <Button variant="outline" className="flex-1" onClick={handleClose}>
              Cancelar
            </Button>
            <Button
              className="flex-1 bg-amber-500 hover:bg-amber-600 text-white"
              onClick={onCriar}
              disabled={loading || totalSelecionado === 0}
            >
              {loading ? 'A criar...' : 'Criar Resgate e Gerar PDF'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
